import _ from "lodash";
import { unformatNumber } from "../../../helpers";

const defaultPromoType = {
  promoTargetItem: {
    target: {
      targetType: "",
      item: [],
      kategori: "",
      brand: "",
      principal: ""
    },
    boundary: {
      boundaryType: [],
      uom: "",
      qty: {
        min: "",
        max: ""
      },
      value: {
        min: "",
        max: ""
      },
      paymentMethod: "",
      customerClass: "",
      customerType: "",
      rgm: "",
      branch: "",
      regionIdn: "",
      oracleCustomerId: "",
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      },
      point: {
        value: "",
        max: ""
      },
      freeItem: {
        oracleItemId: "",
        qty: ""
      }
    }
  },
  promoTargetPaymentMethod: {
    target: {
      targetType: "paymentCode",
      paymentCode: ""
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      },
      point: {
        value: "",
        max: ""
      },
      freeItem: {
        oracleItemId: "",
        qty: ""
      }
    }
  },
  promoTargetCart: {
    target: {
      targetType: "",
      oracleCustomerId: [],
      rgm: "",
      branch: "",
      customerClass: "",
      customerType: ""
    },
    boundary: {
      boundaryType: [],
      uom: "",
      qty: {
        min: "",
        max: ""
      },
      value: {
        min: "",
        max: ""
      },
      paymentMethod: "",
      customerClass: "",
      customerType: "",
      rgm: "",
      branch: "",
      regionIdn: "",
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      },
      point: {
        value: "",
        max: ""
      },
      freeItem: {
        oracleItemId: "",
        qty: ""
      }
    }
  },
  promoTargetStrata: {
    target: {
      targetType: "",
      item: [],
      kategori: "",
      brand: "",
      principal: ""
    },
    boundary: {
      boundaryType: ["branch"],
      branch: "",
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "strata",
      strata: [
        {
          discountValue: "",
          limit: ""
        }
      ],
      strataPriceCut: [
        {
          priceCutValue: "",
          limit: ""
        }
      ]
    }
  },
  voucher: {
    voucherCode: "",
    boundary: {
      boundaryType: [],
      uom: "",
      qty: {
        min: "",
        max: ""
      },
      value: {
        min: "",
        max: ""
      },
      paymentMethod: "",
      customerClass: "",
      customerType: "",
      rgm: "",
      branch: "",
      regionIdn: "",
      multiOracleCustomerId: [],
      province: "",
      regency: "",
      district: "",
    },
    promoValue: {
      promoValueType: "",
      discount: {
        value: "",
        max: ""
      },
      priceCut: {
        value: "",
        max: ""
      }
    }
  },
}

const generateObjectPromoTarget = payload => {
  let promoTarget;
  if (payload.promoType === "payment_method_to_cart") {
    let valuePaymentMethod = {};
    if (payload.promoTargetPaymentMethod) {
      const { target, promoValue } = payload.promoTargetPaymentMethod;
      valuePaymentMethod = {
        ...defaultPromoType,
        promoTargetPaymentMethod: {
          target: {
            targetType: "paymentCode",
            paymentCode: target.paymentCode
          },
          promoValue: {
            promoValueType: promoValue.promoValueType,
            discount: {
              value: promoValue.discount && promoValue.discount.value,
              max: promoValue.discount && promoValue.discount.max
            },
            priceCut: {
              value: promoValue.priceCut && promoValue.priceCut.value,
              max: promoValue.priceCut && promoValue.priceCut.max
            },
            point: {
              value: promoValue.point && promoValue.point.value,
              max: promoValue.point && promoValue.point.max
            },
            freeItem: {
              oracleItemId:
                promoValue.freeItem && promoValue.freeItem.oracleItemId,
              qty: promoValue.freeItem && promoValue.freeItem.qty
            }
          }
        },
      };
    }
    promoTarget = _.defaultsDeep(
      _.omitBy(valuePaymentMethod, _.isNull),
      defaultPromoType,
    );
  } else if (payload.promoType === "promo_to_cart") {
    let tempBoundaryType = [];
    let valueCart = {};
    if (payload.promoTargetCart) {
      const { target, boundary, promoValue } = payload.promoTargetCart;
      Object.keys(boundary).map(item => {
        if (item !== "_id" && item !== "updatedAt" && item !== "createdAt") {
          tempBoundaryType.push(item);
        }
        return item;
      });
      valueCart = {
        ...defaultPromoType,
        promoTargetCart: {
          target: {
            targetType: target.targetType,
            oracleCustomerId: target.oracleCustomerId,
            rgm: target.rgm,
            branch: target.branch,
            customerClass: target.customerClass,
            customerType: target.customerType
          },
          boundary: {
            boundaryType: boundary.boundaryType || tempBoundaryType,
            uom: boundary.uom,
            qty: {
              min: boundary.qty && boundary.qty.min,
              max: boundary.qty && boundary.qty.max
            },
            value: {
              min: boundary.value && boundary.value.min,
              max: boundary.value && boundary.value.max
            },
            paymentMethod: boundary.paymentMethod,
            customerClass: boundary.customerClass,
            customerType: boundary.customerType,
            rgm: boundary.rgm,
            branch: boundary.branch,
            regionIdn: boundary.regionIdn,
            province: boundary.province,
            regency: boundary.regency,
            district: boundary.district,
          },
          promoValue: {
            promoValueType: promoValue.promoValueType,
            discount: {
              value: promoValue.discount && promoValue.discount.value,
              max: promoValue.discount && promoValue.discount.max
            },
            priceCut: {
              value: promoValue.priceCut && promoValue.priceCut.value,
              max: promoValue.priceCut && promoValue.priceCut.max
            },
            point: {
              value: promoValue.point && promoValue.point.value,
              max: promoValue.point && promoValue.point.max
            },
            freeItem: {
              oracleItemId:
                promoValue.freeItem && promoValue.freeItem.oracleItemId,
              qty: promoValue.freeItem && promoValue.freeItem.qty
            }
          }
        },
      };
    }
    promoTarget = _.defaultsDeep(_.omitBy(valueCart, _.isNull), defaultPromoType);
  } else if (payload.promoType === "promo_to_item") {
    let tempBoundaryType = [];
    let valueItem = {};
    if (payload.promoTargetItem) {
      const { target, boundary, promoValue } = payload.promoTargetItem;
      Object.keys(boundary).map(item => {
        if (item !== "_id" && item !== "updatedAt" && item !== "createdAt") {
          tempBoundaryType.push(item);
        }
        return item;
      });
      valueItem = {
        ...defaultPromoType,
        promoTargetItem: {
          target: {
            targetType: target.targetType,
            item: target.item,
            kategori: target.kategori,
            brand: target.brand,
            principal: target.principal
          },
          boundary: {
            boundaryType: boundary.boundaryType || tempBoundaryType,
            uom: boundary.uom,
            qty: {
              min: boundary.qty && boundary.qty.min,
              max: boundary.qty && boundary.qty.max
            },
            value: {
              min: boundary.value && boundary.value.min,
              max: boundary.value && boundary.value.max
            },
            paymentMethod: boundary.paymentMethod,
            customerClass: boundary.customerClass,
            customerType: boundary.customerType,
            rgm: boundary.rgm,
            branch: boundary.branch,
            regionIdn: boundary.regionIdn,
            oracleCustomerId: boundary.oracleCustomerId,
            province: boundary.province,
            regency: boundary.regency,
            district: boundary.district,
          },
          promoValue: {
            promoValueType: promoValue.promoValueType,
            discount: {
              value: promoValue.discount && promoValue.discount.value,
              max: promoValue.discount && promoValue.discount.max
            },
            priceCut: {
              value: promoValue.priceCut && promoValue.priceCut.value,
              max: promoValue.priceCut && promoValue.priceCut.max
            },
            point: {
              value: promoValue.point && promoValue.point.value,
              max: promoValue.point && promoValue.point.max
            },
            freeItem: {
              oracleItemId:
                promoValue.freeItem && promoValue.freeItem.oracleItemId,
              qty: promoValue.freeItem && promoValue.freeItem.qty
            }
          }
        },
      };
    }
    promoTarget = _.defaultsDeep(_.omitBy(valueItem, _.isNull), defaultPromoType);
  } else if (payload.promoType === "strata_disc") {
    let tempBoundaryType = [];
    let valueStrata = {};
    if (payload.promoTargetStrata) {
      const { target, boundary, promoValue } = payload.promoTargetStrata;
      Object.keys(boundary).map(item => {
        if (item !== "_id" && item !== "updatedAt" && item !== "createdAt") {
          tempBoundaryType.push(item);
        }
        return item;
      });
      valueStrata = {
        ...defaultPromoType,
        promoTargetStrata: {
          target: {
            targetType: target.targetType,
            item: target.item,
            kategori: target.kategori,
            brand: target.brand,
            principal: target.principal
          },
          boundary: {
            boundaryType: boundary.boundaryType,
            branch: boundary.branch,
            province: boundary.province,
            regency: boundary.regency,
            district: boundary.district,
          },
          promoValue: {
            promoValueType: promoValue.promoValueType,
            strata: promoValue.strata,
            strataPriceCut: promoValue.strataPriceCut
          }
        },
      };
    }
    promoTarget = _.defaultsDeep(
      _.omitBy(valueStrata, _.isNull),
      defaultPromoType
    );
  } else if (payload.promoType === "voucher") {
    let tempBoundaryType = [];
    let valueVoucher = {};
    if (payload.voucher) {
      const { boundary, promoValue } = payload.voucher;
      Object.keys(boundary).map(item => {
        if (item !== "_id" && item !== "updatedAt" && item !== "createdAt") {
          if (item === 'multiOracleCustomerId') {
            if (boundary[item].length > 0) {
              tempBoundaryType.push(item);
            }
          } else {
            tempBoundaryType.push(item);
          }
        }
        return item;
      });
      valueVoucher = {
        ...defaultPromoType,
        voucher: {
          voucherCode: _.get(payload, 'voucher.voucherCode', ''),
          boundary: {
            boundaryType: boundary.boundaryType || tempBoundaryType,
            uom: _.get(boundary, 'uom', ''),
            qty: {
              min: _.get(boundary, 'qty.min', ''),
              max: _.get(boundary, 'qty.max', ''),
            },
            value: {
              min: _.get(boundary, 'value.min', ''),
              max: _.get(boundary, 'value.max', ''),
            },
            branch: _.get(boundary, 'branch', ''),
            paymentMethod: _.get(boundary, 'paymentMethod', ''),
            customerClass: _.get(boundary, 'customerClass', ''),
            customerType: _.get(boundary, 'customerType', ''),
            rgm: _.get(boundary, 'rgm', ''),
            regionIdn: _.get(boundary, 'regionIdn', ''),
            multiOracleCustomerId: boundary.multiOracleCustomerId || [],
            province: boundary.province,
            regency: boundary.regency,
            district: boundary.district,
          },
          promoValue: {
            promoValueType: _.get(promoValue, 'promoValueType', ''),
            discount: {
              value: _.get(promoValue, 'discount.value', ''),
              max: _.get(promoValue, 'discount.max', ''),
            },
            priceCut: {
              value: _.get(promoValue, 'priceCut.value', ''),
              max: _.get(promoValue, 'priceCut.max', ''),
            }
          }
        },
      };
    }
    promoTarget = valueVoucher
  } else if (payload.promoType === "push_to_cart") {
    let tempBoundaryType = [];
    let valueItem = {};
    if (payload.promoTargetPushCart) {
      const { target, boundary, promoValue } = payload.promoTargetPushCart;
      Object.keys(boundary).map(item => {
        if (item !== "_id" && item !== "updatedAt" && item !== "createdAt") {
          tempBoundaryType.push(item);
        }
        return item;
      });
      valueItem = {
        ...defaultPromoType,
        promoTargetPushCart: {
          target: {
            targetType: target.targetType,
            oracleItemId: target.oracleItemId,
          },
          boundary: {
            boundaryType: boundary.boundaryType || tempBoundaryType,
            customerClass: boundary.customerClass,
            customerType: boundary.customerType,
          },
          promoValue: {
            promoValueType: promoValue.promoValueType,
            discount: {
              value: promoValue.discount && promoValue.discount.value,
              max: promoValue.discount && promoValue.discount.max
            },
          }
        },
      };
    }
    promoTarget = _.defaultsDeep(_.omitBy(valueItem, _.isNull), defaultPromoType);
  }
  return promoTarget;
};

/**
 * untuk hapus key object yang tidak dipilih
 */
const removeKeyOne = (obj, letter, except) => {
  Object.keys(obj).forEach(function (key) {
    if (key !== except) {
      if (key !== letter) delete obj[key];
    }
  });
}
/**
 * untuk hapus key object yang tidak dipilih
 */
const removeKeyMany = (obj, letter, except) => {
  Object.keys(obj).forEach(function (key) {
    if (key !== except) {
      if (!letter.includes(key)) delete obj[key];
    }
  });
}

const mutationFormPromo = (promo) => {
  let target, promoValue, boundary;

  if (promo.promoType === 'payment_method_to_cart') {
    const { discount } = promo.promoTargetPaymentMethod.promoValue
    if (discount.max === "" || discount.max === null) discount.max = 'Infinity'
    target = promo.promoTargetPaymentMethod.target;
    promoValue = promo.promoTargetPaymentMethod.promoValue;
    delete promo.promoTargetItem;
    delete promo.promoTargetCart;
    delete promo.promoTargetStrata;
    delete promo.voucher;
    delete promo.promoTargetPushCart;
  } else if (promo.promoType === 'promo_to_cart') {
    const { qty, value } = promo.promoTargetCart.boundary
    const { discount, priceCut, point, freeItem } = promo.promoTargetCart.promoValue
    if (qty.max === "" || qty.max === null) qty.max = 'Infinity'
    if (value) {
      !value.max ? value.max = 'Infinity' : value.max = unformatNumber(value.max)
      !value.min ? value.min = 'Infinity' : value.min = unformatNumber(value.min)
    }
    if (priceCut) {
      if (priceCut.max === "" || priceCut.max === null) priceCut.max = 'Infinity'
      else priceCut.max = parseInt(priceCut.max.toString().split('.').join(''))
      if (priceCut.value) priceCut.value = parseInt(priceCut.value.toString().split('.').join(''))
    }
    if (discount) {
      if (discount.max === "" || discount.max === null) discount.max = 'Infinity'
      else discount.max = parseInt(discount.max.toString().split('.').join(''))
      if (discount.value) discount.value = parseInt(discount.value.toString().split('.').join(''))
    }
    if (point) {
      if (point.max === "" || point.max === null) point.max = 'Infinity'
      else point.max = parseInt(point.max.toString().split('.').join(''))
      if (point.value) point.value = parseInt(point.value.toString().split('.').join(''))
    }
    if (freeItem) if (freeItem.qty) freeItem.qty = parseInt(freeItem.qty.toString().split('.').join(''))
    target = promo.promoTargetCart.target;
    promoValue = promo.promoTargetCart.promoValue;
    boundary = promo.promoTargetCart.boundary;
    delete promo.promoTargetItem;
    delete promo.promoTargetPaymentMethod;
    delete promo.promoTargetStrata;
    delete promo.voucher;
    delete promo.promoTargetPushCart;
    if (boundary.branch === '') {
      boundary.branch = null
    }
  } else if (promo.promoType === 'promo_to_item') {
    const { qty, value } = promo.promoTargetItem.boundary
    const { priceCut, discount, point, freeItem } = promo.promoTargetItem.promoValue
    if (qty) if (qty.max === "" || qty.max === null) qty.max = 'Infinity'
    if (value) {
      !value.max ? value.max = 'Infinity' : value.max = unformatNumber(value.max)
      !value.min ? value.min = 'Infinity' : value.min = unformatNumber(value.min)
    }
    if (priceCut) {
      if (priceCut.max === "" || priceCut.max === null) priceCut.max = 'Infinity'
      else priceCut.max = parseInt(priceCut.max.toString().split('.').join(''))
      if (priceCut.value) priceCut.value = parseInt(priceCut.value.toString().split('.').join(''))
    }
    if (discount) {
      if (discount.max === "" || discount.max === null) discount.max = 'Infinity'
      else discount.max = parseInt(discount.max.toString().split('.').join(''))
      if (discount.value) discount.value = parseInt(discount.value.toString().split('.').join(''))
    }
    if (point) {
      if (point.max === "" || point.max === null) point.max = 'Infinity'
      else point.max = parseInt(point.max.toString().split('.').join(''))
      if (point.value) point.value = parseInt(point.value.toString().split('.').join(''))
    }
    if (freeItem) if (freeItem.qty) freeItem.qty = parseInt(freeItem.qty.toString().split('.').join(''))
    target = promo.promoTargetItem.target;
    promoValue = promo.promoTargetItem.promoValue;
    boundary = promo.promoTargetItem.boundary;
    delete promo.promoTargetPaymentMethod;
    delete promo.promoTargetCart;
    delete promo.promoTargetStrata;
    delete promo.voucher;
    delete promo.promoTargetPushCart;
    if (boundary.branch === '') {
      boundary.branch = null
    }
  } else if (promo.promoType === 'strata_disc') {
    target = promo.promoTargetStrata.target;
    promoValue = promo.promoTargetStrata.promoValue;
    boundary = promo.promoTargetStrata.boundary;
    delete promo.promoTargetPaymentMethod;
    delete promo.promoTargetCart;
    delete promo.promoTargetItem;
    delete promo.voucher;
    delete promo.promoTargetPushCart;
    if (boundary.branch === '') {
      boundary.branch = null
    }
  } else if (promo.promoType === 'voucher') {
    const { qty, value } = promo.voucher.boundary
    const { discount, priceCut } = promo.voucher.promoValue
    if (qty.max === "" || qty.max === null) qty.max = 'Infinity'

    !value.max ? value.max = 'Infinity' : value.max = unformatNumber(value.max)
    !value.min ? value.min = 'Infinity' : value.min = unformatNumber(value.min)

    !discount.max ? discount.max = 'Infinity' : discount.max = unformatNumber(discount.max)
    !discount.value ? discount.value = 'Infinity' : discount.value = unformatNumber(discount.value)

    !priceCut.max ? priceCut.max = 'Infinity' : priceCut.max = unformatNumber(priceCut.max)
    !priceCut.value ? priceCut.value = 'Infinity' : priceCut.value = unformatNumber(priceCut.value)

    promoValue = promo.voucher.promoValue;
    boundary = promo.voucher.boundary;
    delete promo.promoTargetPaymentMethod;
    delete promo.promoTargetCart;
    delete promo.promoTargetItem;
    delete promo.promoTargetStrata;
    delete promo.promoTargetPushCart;
    if (boundary.branch === '') {
      boundary.branch = null
    }
  } else if (promo.promoType === 'push_to_cart') {
    const { discount } = promo.promoTargetPushCart.promoValue
    if (discount) {
      if (discount.max === "" || discount.max === null) discount.max = 'Infinity'
      else discount.max = parseInt(discount.max.toString().split('.').join(''))
      if (discount.value) discount.value = parseInt(discount.value.toString().split('.').join(''))
    }
    target = promo.promoTargetPushCart.target;
    boundary = promo.promoTargetPushCart.boundary;
    promoValue = promo.promoTargetPushCart.promoValue;
    delete promo.promoTargetPaymentMethod;
    delete promo.promoTargetCart;
    delete promo.promoTargetStrata;
    delete promo.voucher;
    delete promo.promoTargetItem;
  }
  if (promo.promoType !== 'voucher') {
    removeKeyOne(target, target.targetType, "targetType");
  }
  removeKeyOne(
    promoValue,
    promoValue.promoValueType,
    "promoValueType"
  );
  if (promo.promoType !== 'payment_method_to_cart') {
    removeKeyMany(boundary, boundary.boundaryType, "boundaryType");
  }
  if (promo.budgetBy) {
    promo.budgetBy = 1
  } else {
    promo.budgetBy = 0
  }
  return promo
}

export { generateObjectPromoTarget, mutationFormPromo };
